import { Box } from "@mui/material";
import ActivitiesView from "../../components/activity-list/ActivitiesView";
import FabEyeButton from "../../components/user-activity-fab/UserActivityFab";

const ActivityPage = () => {
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <ActivitiesView />
      <FabEyeButton />
    </Box>
  );
};

export default ActivityPage;
